import React, { ReactText } from 'react';
import {
  ApButtonGroup,
  ApButtonMain,
  ApButtonSecondary,
  ApSearchDropdown,
} from '@alixpartners/ui-components';
import {
  StyledModal,
  TextContent,
  ControlArea,
  DropdownWrapper,
  Label,
} from './ClassificationModalEditor.styles';
import { getTextByType } from './utils';
import { ITaxonomyItem, SpendTypeEnum } from '..';

type TValue = Pick<ITaxonomyItem, 'apL1Category' | 'apL2Category'>;

interface IState {
  selectedL1?: string;
  selectedL2?: string;
  inputL1?: string;
  inputL2?: string;
}

interface IProps {
  spendType: SpendTypeEnum;
  isOpen: boolean;
  onSubmit(data: ITaxonomyItem): void;
  onClose(): void;
  options: ITaxonomyItem[];
  value?: TValue;
  isRule?: boolean;
  isDisabled?: boolean;
}

export class ClassificationModalEditor extends React.Component<IProps, IState> {
  state = {
    inputL1: '',
    inputL2: '',
    ...this.getInitialState(),
  };

  getInitialState() {
    const { value } = this.props;

    if (value) {
      return {
        inputL1: value.apL1Category,
        inputL2: value.apL2Category,
        selectedL1: value.apL1Category,
        selectedL2: value.apL2Category,
      };
    }

    return {};
  }

  handleSubmit = () => {
    const { onSubmit, options } = this.props;
    const { selectedL1, selectedL2 } = this.state;
    const value = options.find(
      (option) =>
        option.apL1Category === selectedL1 && option.apL2Category === selectedL2
    );

    if (value) {
      onSubmit(value);
    }
  };

  handleL1Change = (value: ReactText) => {
    this.setState({
      inputL1: value.toString(),
    });
  };

  handleL2Change = (value: ReactText) => {
    this.setState({ inputL2: value.toString() });
  };

  handleL1OnBlur = ({ target }: React.SyntheticEvent) => {
    const { selectedL1 } = this.state;

    if (target) {
      this.setState(
        {
          inputL1: '',
        },
        () => {
          this.setState({
            inputL1: selectedL1,
          });
        }
      );
    }
  };

  handleL2OnBlur = ({ target }: React.SyntheticEvent) => {
    const { selectedL2 } = this.state;

    if (target) {
      this.setState(
        {
          inputL2: '',
        },
        () => {
          this.setState({
            inputL2: selectedL2,
          });
        }
      );
    }
  };

  handleL1Select = (value: ReactText) => {
    this.setState({
      selectedL1: value.toString(),
      selectedL2: undefined,
      inputL2: '',
    });
  };

  handleL2Select = (value: ReactText) => {
    this.setState({ selectedL2: value.toString() });
  };

  getL1Options() {
    const { options } = this.props;

    return [...new Set(options.map(({ apL1Category }) => apL1Category))].map(
      (value) => ({
        name: value,
        value,
      })
    );
  }

  getL2Options() {
    const { options } = this.props;
    const { selectedL1 } = this.state;

    return options
      .filter((item) => item.apL1Category === selectedL1)
      .map(({ apL2Category }) => ({
        name: apL2Category,
        value: apL2Category,
      }));
  }

  render() {
    const {
      isOpen,
      isRule,
      onClose,
      isDisabled,
      spendType,
      value,
    } = this.props;
    const { selectedL1, selectedL2, inputL1, inputL2 } = this.state;
    const isSubmitDisabled = isDisabled || !selectedL1 || !selectedL2;
    const textObj = getTextByType(spendType, isRule, !value);

    return (
      <StyledModal
        isOpen={isOpen}
        header={textObj.title}
        isDismissible
        hasClosed={onClose}
        footer={({ handleClose }) => {
          return (
            <ApButtonGroup justifyContent="flex-end">
              <ApButtonSecondary onClick={handleClose}>
                Cancel
              </ApButtonSecondary>
              <ApButtonMain
                disabled={isSubmitDisabled}
                onClick={this.handleSubmit}
              >
                {textObj.submit}
              </ApButtonMain>
            </ApButtonGroup>
          );
        }}
      >
        <TextContent>{textObj.content}</TextContent>
        <ControlArea>
          <DropdownWrapper>
            <Label>L1 Service Tower</Label>
            <ApSearchDropdown
              options={this.getL1Options()}
              value={inputL1}
              placeholder="Type or select Service Tower"
              onSuggestionSelected={this.handleL1Select}
              onInputChange={this.handleL1Change}
              onInputBlur={this.handleL1OnBlur}
            />
          </DropdownWrapper>
          <DropdownWrapper disabled={!selectedL1}>
            <Label>L2 Spend category *</Label>
            <ApSearchDropdown
              options={this.getL2Options()}
              value={inputL2}
              placeholder="Type or select category"
              onSuggestionSelected={this.handleL2Select}
              onInputChange={this.handleL2Change}
              onInputBlur={this.handleL2OnBlur}
            />
          </DropdownWrapper>
        </ControlArea>
      </StyledModal>
    );
  }
}
